import React from "react";
import { copyToClipboard } from "../utils";

export function Resumen({ weekKey, tareas, resumen, resumenLoading, resumenErr, copied, onGenerarResumen, onCopied }) {
  const handleGenerarResumen = async () => {
    onGenerarResumen();
  };

  const handleCopiar = () => {
    copyToClipboard(resumen)
      .then(() => onCopied())
      .catch(err => console.error("Error al copiar:", err));
  };

  return (
    <div>
      <p style={{ marginBottom: "20px", fontSize: "14.5px", color: "var(--text-muted)", lineHeight: 1.6 }}>
        Generá un resumen ejecutivo consolidado del mes <strong>{weekKey}</strong> utilizando Inteligencia Artificial. 
        El texto se formateará estructuradamente, ideal para ser enviado por WhatsApp o correo institucional.
      </p>

      <div style={{ marginBottom: "24px" }}>
        <button 
          onClick={handleGenerarResumen}
          className="btn-accent"
          disabled={resumenLoading}
          style={{ padding: "11px 20px" }}
        >
          {resumenLoading ? (
            <>
              <span className="spinner" style={{ marginRight: "4px" }}></span> Analizando tareas...
            </>
          ) : (
            <>
              <i className="ti ti-sparkles" style={{ fontSize: "15px" }}></i> Generar Resumen Ejecutivo
            </>
          )}
        </button>
      </div>

      {resumenErr && (
        <div style={{ background: "var(--bg-bloqueada)", border: "1px solid rgba(220, 38, 38, 0.15)", borderRadius: "6px", padding: "16px", marginBottom: "20px", fontSize: "14px", color: "var(--color-bloqueada)" }}>
          <div style={{ display: "flex", gap: "8px", alignItems: "center", fontWeight: "600" }}>
            <i className="ti ti-alert-triangle" style={{ fontSize: "18px" }}></i>
            <span>Error al conectar con la IA</span>
          </div>
          <p style={{ marginTop: "4px", fontSize: "13.5px", color: "var(--text-muted)" }}>{resumenErr}</p>
          <div style={{ marginTop: "12px" }}>
            <button onClick={handleGenerarResumen} className="btn-info" style={{ padding: "6px 12px", fontSize: "13px" }}>
              <i className="ti ti-refresh"></i> Reintentar
            </button>
          </div>
        </div>
      )}

      {resumen ? (
        <div className="card" style={{ padding: "20px", background: "var(--bg-page)", border: "1px solid var(--border-color)" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "14px", borderBottom: "1px solid var(--border-color)", paddingBottom: "10px" }}>
            <span style={{ fontWeight: "600", fontSize: "15px", color: "var(--text-dark)", letterSpacing: "0.02em" }}>
              <i className="ti ti-report-analytics" style={{ color: "var(--accent)", marginRight: "6px" }}></i>
              TEXTO GENERADO
            </span>
            <button 
              onClick={handleCopiar}
              className={copied ? "btn-success" : "btn-primary"}
              style={{ padding: "6px 12px", fontSize: "13px" }}
            >
              <i className={`ti ti-${copied ? "check" : "copy"}`}></i> {copied ? "¡Copiado!" : "Copiar Texto"}
            </button>
          </div>
          <pre className="resumen-pre" style={{ margin: 0, background: "#ffffff" }}>{resumen}</pre>
        </div>
      ) : !resumenLoading ? (
        <div className="empty-state" style={{ padding: "30px 20px" }}>
          <i className="ti ti-sparkles" style={{ fontSize: "36px", color: "var(--text-light)" }}></i>
          <div style={{ fontSize: "14px", color: "var(--text-muted)", marginTop: "8px" }}>Hacé clic en el botón superior para procesar las actividades cargadas.</div>
        </div>
      ) : null}
    </div>
  );
}
